// extracted by mini-css-extract-plugin
var _1 = "eI0gKMQGNOV7sTSGAJ9N";
var _2 = "nqvMlKT9lrm_inXI7u03";
export { _1 as "form", _2 as "root" }
